type ServiceOption = {
  name: string
  price: number
  selected?: boolean
}

export type ServiceOptions = {
  mot: ServiceOption
  oilAndFilter: ServiceOption
  standardService: ServiceOption
  fullService: ServiceOption
  standardServiceEV: ServiceOption
  fullServiceEV: ServiceOption
}

export const serviceOptionDefaults: ServiceOptions = {
  mot: {
    name: 'MOT',
    price: 39.95,
  },
  oilAndFilter: {
    name: 'Oil & filter change',
    price: 129.95,
  },
  standardService: {
    name: 'Standard service',
    price: 159.95,
  },
  fullService: {
    name: 'Full service',
    price: 214.95,
  },
  standardServiceEV: {
    name: 'Standard EV service',
    price: 159.95,
  },
  fullServiceEV: {
    name: 'Full EV service',
    price: 214.95,
  },
}

export enum ContactTimePreference {
  AM = 'AM',
  PM = 'PM',
}

export enum VehicleType {
  EV = 'Ev',
  COMBUSTIBLE = 'Combustible',
}

export type AppointmentType = 'Drop and go' | 'Drop and wait'

export type BookingRequest = {
  customer: Customer
  vehicle: Vehicle
  bookingDetails: BookingDetails
  campaignId?: string
  deviceContext?: 'web' | 'app'
}

type Vehicle = {
  vin: string
  vrm: string
  mileage: number
  make?: string
  model?: string
}

type BookingDetails = {
  storeId: string
  storeName?: string
  bookingDate: string
  bookingTime: string
  appointmentTypeId: number
  serviceOptions: BookingDetailsServiceOptions[]
}

type BookingDetailsServiceOptions = {
  serviceType: string
  description: string
}

type Customer = {
  title: string
  firstName: string
  lastName: string
  mobile: string
  email: string
  address: Address
}

type Address = {
  street: string
  city?: string
  county?: string
  postCode: string
}

export type CustomerAddress = {
  addressLine1: string
  addressLine2?: string
  postTown: string
  county: string
  postcode: string
}
